import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import MenuSidebarContext from './menuSidebarContext';
import './custom.css';

function pathMatches(locationPath, routes) {
  if (!routes || !routes.length) return false;
  const current = (locationPath || '').toLowerCase();
  return routes.some(route => {
    const target = (route || '').toLowerCase();
    if (!target) return false;
    return current === target || current.startsWith(`${target}/`);
  });
}

class MenuTree extends Component {
  constructor(props) {
    super(props);
    this.handleToggle = this.handleToggle.bind(this);
    this.ensureOpenForRoute = this.ensureOpenForRoute.bind(this);
  }

  ensureOpenForRoute() {
    const { id, paths, location } = this.props;
    const { setOpenTreeId } = this.context;
    if (id && paths && pathMatches(location && location.pathname, paths)) {
      setOpenTreeId(id);
    }
  }

  componentDidMount() {
    this.ensureOpenForRoute();
  }

  componentDidUpdate(prevProps) {
    const prevPath = prevProps.location && prevProps.location.pathname;
    const nextPath = this.props.location && this.props.location.pathname;
    if (prevPath !== nextPath) {
      this.ensureOpenForRoute();
    }
  }

  handleToggle(event) {
    event.preventDefault();
    event.stopPropagation();
    const { id } = this.props;
    const { openTreeId, setOpenTreeId } = this.context;
    setOpenTreeId(openTreeId === id ? null : id);
  }

  render() {
    const { openTreeId } = this.context;
    const open = openTreeId === this.props.id;
    const liClass = open ? 'treeview menu-open active' : 'treeview';

    return (
      <li className={liClass} data-react-treeview="true">
        <a className="menu_item" href="/" onClick={this.handleToggle}>
          <i className={`fa fa-${this.props.icon}`} /> <span>{this.props.label}</span>
          <span className="pull-right-container">
            <i className="fa fa-angle-left pull-right" />
          </span>
        </a>
        <ul className="treeview-menu">{this.props.children}</ul>
      </li>
    );
  }
}

MenuTree.contextType = MenuSidebarContext;
MenuTree.defaultProps = {
  paths: [],
};

export default withRouter(MenuTree);
